import React, { useEffect } from 'react';
// import { NotificationManager } from 'react-notifications';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import {
  getNotifications,
  markNotificationsRead,
} from '../../actions/price_actions';
import { getSuggestions } from '../../actions/updatePrice';
import { getPriceCards } from '../../actions/dashboard';
import { bindActionCreators } from 'redux';

const showNotitification = (data) => {
  let {
    type,
    title,
    message,
    markNotificationsRead,
    id,
    notificationData,
    getPriceCards,
  } = data;
  let getToastContent = (message, title) => {
    return (
      <div>
        {title ? <h5>{title}</h5> : null}
        {message}
      </div>
    );
  };
  let handleClose = () => {
    if (id !== 0 && notificationData) {
      markNotificationsRead([id]);
      if (notificationData.Type === 'freeze_price' && notificationData.isToday)
        getPriceCards();
    }
  };
  switch (type) {
    case 'info':
      toast.info(getToastContent(message, title), {
        position: toast.POSITION.TOP_RIGHT,
        onClose: handleClose,
      });
      break;
    case 'success':
      toast.success(getToastContent(message, title), {
        position: toast.POSITION.TOP_RIGHT,
      });
      break;
    case 'warning':
      toast.warning(getToastContent(message, title), {
        position: toast.POSITION.TOP_RIGHT,
      });
      break;
    case 'error':
      toast.error(getToastContent(message, title), {
        position: toast.POSITION.TOP_RIGHT,
      });
      break;
    default:
      break;
  }
};

function Notifications(props) {
  let {
    message,
    type,
    getNotifications,
    getSuggestions,
    lastId,
    title,
    authenticated,
    markNotificationsRead,
    id,
    notificationData,
    getPriceCards,
  } = props;

  useEffect(() => {
    if (authenticated) {
      getNotifications(lastId);

      let interval = setInterval(
        (lastId) => {
          getNotifications(lastId);
        },
        30000,
        lastId
      );
      return () => clearInterval(interval);
    }
  }, [getNotifications, getSuggestions, lastId, authenticated]);

  useEffect(() => {
    showNotitification({
      type,
      title,
      id,
      message,
      markNotificationsRead,
      notificationData,
      getPriceCards,
    });
  }, [
    type,
    title,
    id,
    message,
    markNotificationsRead,
    notificationData,
    getPriceCards,
  ]);

  return <></>;
}
const mapStateToProps = (state) => ({
  message: state.notification.message,
  title: state.notification.title,
  type: state.notification.type,
  id: state.notification.id,
  lastId: state.notification.lastId,
  authenticated: state.login.authenticated,
  notificationData: state.notification.notificationData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getNotifications,
      markNotificationsRead,
      getPriceCards,
      getSuggestions,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
